/**
 * Patch global para suprimir erro "Cannot read properties of null (reading 'node')"
 * do ApexCharts. O runMaskReveal é chamado via requestAnimationFrame e tenta acessar
 * um nó SVG que pode não existir quando o gráfico está dentro de LazySection/Suspense.
 */
(function patchRAF() {
  if (typeof window === 'undefined') return;
  const origRAF = window.requestAnimationFrame;
  if (!origRAF) return;
  window.requestAnimationFrame = function (cb) {
    return origRAF.call(window, function () {
      try {
        cb.apply(this, arguments);
      } catch (e) {
        if (e && e.message && e.message.includes("reading 'node'")) {
          console.warn('ApexCharts animation error suppressed (SVG node not ready)');
          return;
        }
        throw e;
      }
    });
  };
})();
